<template>

  <form @submit.prevent="onSubmit">
    

    <template v-if="notActivated" >
      
      <div v-if="selectedPlan" class="field">
      <div class="SubscriptionPriceDisplay">
          <div class="currency">
            <div class="symbol">
              {{ selectedPlan.currency_symbol }}
            </div>
            <div class="code">
              {{ selectedPlan.currency_code }}
            </div>
          </div>
          <div class="item">
            <div class="amount">
              {{ selectedPlan.price_per_user }}
            </div>
            <div class="per">
              <b>per user per month,</b> charged on a monthly basis
            </div>
          </div>
        </div>
        
        <div style="margin-top:0.2em;">
          <button @click="changePlan=!changePlan" type="button" class="fakelink" ><i class="fa fa-pencil-alt btn_icon"></i>Change currency</button>
        </div>

        <div v-if="!selectedPlan || changePlan" class="ChangeSubscriptionSelect" >
          <label for="name" class="field_label">Which currency would you like to pay with?</label>
          <div class="CurrencySelect">
            <label v-for="option in options" :key="option.id" >
              <input type="radio" name="plan" :value="option.id" v-model="plan" >
              <span>
                <span>{{ option.currency_symbol }}</span>
                <span>{{ option.currency_code }}</span>
              </span>
            </label>
          </div>
        </div>

      </div>


    </template>
    
    <!-- <div class="field">
      <label for="name" class="field_label">Name on Card</label>
        <input v-model="cardName" name="card_name" autocomplete="card_name" autofocus="autofocus" required="required" type="text">
    </div> -->
    <div class="field">
      <label for="stripe-target" class="field_label">{{ notActivated ? 'Card Details' : 'New Card Details' }}</label>
      <label :class="{'in-base':1,'fake-focus':stripeFocused}" style="padding:9px;" >
        <div id="stripe-target" ref="stripeTarget">loading...</div>
      </label>
    </div>

    <div class="field p-box-less c-bg-grey-pale" v-if="notActivated" >
      <template v-if="!changeBillingEmail">
        <p>Billing emails will be sent to <button class="fakelink" type="button" @click="changeBillingEmail = true" title="Send to different email" style="white-space:nowrap" ><b>{{ billingEmail }}<i class="fa fa-pencil-alt c-grey-mid" style="margin-left:0.5em;font-size:0.8em"></i></b></button> </p>
      </template>
      <template v-else >
        <label for="name" class="field_label">What email address would you like us to send billing emails to?</label>
        <input v-model="billingEmail" name="billing_email" autocomplete="billing_email" autofocus="autofocus" required="required" type="email" >
      </template>
    </div>

    <div class="field_submit">
      <p style="text-align:left;" class="s-below-less" v-if="notActivated" >
      By activating your account, you agree to our <a :href="publicUrl('/terms')" target="_blank" class="external-link" >Terms &amp; Conditions of service</a> and <a :href="publicUrl('/terms#privacy')" target="_blank" class="external-link" >Privacy policy</a>.
      </p>

      <button :disabled="submitting" :class="['btn-a',notActivated?'btn-big fullwidth':'',submitting?'_btn_submitting':'']">
				<i class="fa fa-rocket btn_icon" v-if="notActivated" ></i>
				{{ notActivated ? 'Activate account' : 'Update payment card' }}
			</button>
    </div>
  </form>

</template>

<script>

	export default {
    props : ['org','onSuccess'],
    data(){
      return {
				notActivated: !this.org.subscription.subscribed,
				options : [
					{
						id : 'plan_basic_monthly_usd_700',
						currency_code : 'USD',
						currency_symbol : '$',
						price_per_user : 7.00,
					},
					{
						id : 'plan_basic_monthly_gbp_500',
						currency_code : 'GBP',
						currency_symbol : '£',
						price_per_user : 5.00,
					},
					{
						id : 'plan_basic_monthly_eur_600',
						currency_code : 'EUR',
						currency_symbol : '€',
						price_per_user : 6.00,
					},
        ],
				billingEmail: this.org.billing_email || this.$store.state.auth.user.email,
				plan: this.org.subscription.plan || this.guessPlan(),
				changeBillingEmail: false,
				changePlan: false,
				// cardName: null,
				stripeFocused: false,
				stripeLoading: true,
				stripe: false,
				stripeCardElement: false,
				paymentIntent: false,
				submitting: false,
      }
    },

		mounted() {

			// Load stripe in the background if we haven't already
			if (typeof Stripe == 'undefined') {
				let script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://js.stripe.com/v3/';
				document.getElementsByTagName('body')[0].appendChild(script);
			}

			// Setup stripe once loaded
      this.waitFor(() => typeof Stripe != 'undefined').then(this.setupStripe);
      
      // Show input once stripe is ready
      this.waitFor(() => this.stripe).then(this.showCardInput);

      // Get a payment intent from the server (arguably should be in vuex)
      this.getSetupIntent();
    },

    
    computed:{
			selectedPlan(){
				var id = this.plan;
				var plans = this.options.filter(x=>x.id==id);
				return plans ? plans[0] : null;
			},
    },


    
    watch:{
			plan(){
				this.changePlan=false;
			},
    },


		methods: {

			onSubmit : function(payload){
				if (this.submitting) return;
				this.submitting = true;
				this.waitFor(() => this.paymentIntent).then(this.setupCard);
      },
      

      ///////////////


      guessPlan() {
        var bcp_47 = ((navigator||{}).language||'').toLowerCase();

        var gbp_countries = ['-gb','cy'];
        // Austria, Belgium, Cyprus, Estonia, Finland, France, Germany, Greece, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, the Netherlands, Portugal, Slovakia, Slovenia, and Spain
        var eur_countries = ['-at','-be','-cy','-ee','-fi','-fr','-de','-gr','-ie','-it','-lv','-lt','-lu','-mt','-nl','-pt','-sk','-si','-es'];
        

        function isMatch(bcp,test){
					if( test.substring(0,1) == '-' ){
            return bcp.substring(bcp.length-test.length) == test;
          }
          return bcp == test;
        }

        function matchesGroup(bcp,group){
          return group.reduce((found,test)=>(found||isMatch(bcp,test)),false);
        }

        if(matchesGroup(bcp_47,gbp_countries)) return 'plan_basic_monthly_gbp_500';
        if(matchesGroup(bcp_47,eur_countries)) return 'plan_basic_monthly_eur_600';
        return 'plan_basic_monthly_usd_700';

      },


      setupStripe() {
				this.stripe = Stripe(window.APP_CONFIG.stripe);
				this.stripeCardElement = this.stripe.elements().create('card',{
					style:{
						base: {
							fontSize: '16px',
							fontFamily: 'Lato, sans-serif',
							color: "#000",
							iconColor : "#6800f1",
						}
					}
				});
      },
      
      
			getSetupIntent() {
				if (this.paymentIntent) return;

				api.call('get', '/orgs/' + this.org.id + '/subscription/setup').then(({data}) => {
					this.paymentIntent = data;
				});
      },
      

			showCardInput() {
				this.stripeLoading = true;

				// Render card input (this is done on next tick to allow the stripeTarget
				// element to actually be rendered in the DOM)
				this.$nextTick(() => {
					this.stripeCardElement.mount(this.$refs.stripeTarget);
					this.stripeCardElement.on('ready', () => this.stripeLoading = false);
					this.stripeCardElement.on('focus', () => this.stripeFocused = true);
					this.stripeCardElement.on('blur', () => this.stripeFocused = false);
				});
      },

      
			setupCard() {
				this.stripe.handleCardSetup(
					this.paymentIntent.client_secret,
					this.stripeCardElement,
					{
						payment_method_data: {
							billing_details: { 
								// name: this.cardName 
							}
						}
					}
				).then(({ setupIntent, error }) => {
					if (error) {
						// Display "error.message" to the user...
						console.log('error', error);
						alert(error.message); // :(

						// Kick off request for new setup intent
						this.paymentIntent = false;
						this.getSetupIntent();

						this.submitting = false;
					} else {
						// The card has been verified successfully...
						// Send them to our server to complete setup
						let method;
						let payload = {
							payment_method: setupIntent.payment_method
						};

						if (this.org.subscription.subscribed) {
							// Update
							method = 'put'
						} else {
							// New subscription
							method = 'post'
							payload.billing_email = this.billingEmail;
							payload.plan = this.plan;
						}

						api.call(method, '/orgs/' + this.org.id + '/subscription', payload).then(() => {
							this.$store.dispatch('auth/refreshOrgs', this.org.id).then(()=>{
								this.submitting = false;
								this.onSuccess();
							});
						}, () => {
							alert('Error saving card details');
							this.submitting = false;
						});
					}
				});
      },
      

			waitFor(test) {
				if (test()) return Promise.resolve();

				return new Promise(resolve => {
					// Watch for test to complete
					let watcher = setInterval(() => {
						if (test()) {
							clearInterval(watcher);
							resolve();
						}
					}, 20);
				});
      }
      

		}
	}
</script>